// Names, initials and colours for assignee bubbles.
import { TaskUser } from '../types/tasks';
import { USER_COLORS, isSolidColor } from './userColors';

// Used for people who haven't picked a colour in Admin › Users yet (or have
// a light one from before the picker): a steady palette colour per email.
const PALETTE = USER_COLORS.map((c) => c.value);

function hash(text: string): number {
  let h = 0;
  for (let i = 0; i < text.length; i++) h = (h * 31 + text.charCodeAt(i)) | 0;
  return Math.abs(h);
}

export function findUser(users: TaskUser[], email: string | null | undefined): TaskUser | undefined {
  return email ? users.find((u) => u.email === email) : undefined;
}

export function userName(users: TaskUser[], email: string | null | undefined): string {
  if (!email) return 'Unassigned';
  if (email === 'system') return 'MPP Command';
  const user = findUser(users, email);
  if (user?.display_name) return user.display_name;
  const local = email.split('@')[0];
  return local.charAt(0).toUpperCase() + local.slice(1);
}

export function firstName(users: TaskUser[], email: string | null | undefined): string {
  return userName(users, email).split(' ')[0];
}

export function userInitial(users: TaskUser[], email: string | null | undefined): string {
  return userName(users, email).trim().charAt(0).toUpperCase() || '?';
}

export function userColor(users: TaskUser[], email: string | null | undefined): string {
  if (!email) return '#B8B8B2';
  const own = findUser(users, email)?.user_color;
  if (own && isSolidColor(own)) return own;
  return PALETTE[hash(email) % PALETTE.length];
}
